<template>
  <!--新增消息模板分类-->
  <addCategory></addCategory>
</template>

<script>
import addCategory from '@/components/package/addCategory.vue';
export default {
  components: {
    addCategory
  },
  name: 'addMsgtplCate'
};
</script>

<style scoped>

</style>
